<div class="row">
    <div class="column">
        <div class="row">
            <section>
                <div class="card">
                    <div cdkDropListGroup>
                        <h2>WELCOME DRINK</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                            @for (item of welcomedrink; track item) {
                            <li [cdkOption]="item" class="example-option">
                                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title> {{item.text}} </mat-panel-title>
                                        <mat-panel-description> </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div class='parent'>
                                        <div class='child'>{{item.typedesc}}</div>
                                        <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                    </div>
                                </mat-expansion-panel>
                              }
                        </ul>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>STARTERS(VEG)</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of vegstarter; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>STARTERS(NON-VEG)</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of nvegstarter; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>LIVE CHAT COUNTERS</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of chatcounters; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>LIVE GRILL & KEBAB COUNTERS</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of grill; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>LIVE ORIENTAL COUNTER</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of oriental; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="row">
            <section>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>SOUPS</h2>
                            <ul cdkListbox cdkListboxMultiple [(ngModel)]="order" class="example-listbox">
                                @for (item of soup; track item) {
                                <li [cdkOption]="item" class="example-option">
                                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{item.text}} </mat-panel-title>
                                            <mat-panel-description> </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class='parent'>
                                            <div class='child'>{{item.typedesc}}</div>
                                            <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                                        </div>
                                    </mat-expansion-panel>
                                    }
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>SALADS</h2>
                            <div cdkDropList #no8="cdkDropList" [cdkDropListData]="salad"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of salad; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>FRIED ITEMS</h2>
                            <div cdkDropList #no9="cdkDropList" [cdkDropListData]="frieditem"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of frieditem; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>BREADS</h2>
                            <div cdkDropList #no10="cdkDropList" [cdkDropListData]="bread"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of bread; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>RICE & BIRIYANI</h2>
                            <div cdkDropList #no11="cdkDropList" [cdkDropListData]="rice"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of rice; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>DAL</h2>
                            <div cdkDropList #no12="cdkDropList" [cdkDropListData]="dal"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of dal; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}
                                 <img *cdkDragPreview [src]="item.image" [alt]="item.text">
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="row">
            <section>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>VEG MAIN COURSE</h2>
                            <div cdkDropList #no13="cdkDropList" [cdkDropListData]="vegmain"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of vegmain; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>NON-VEG CHICKEN MAIN COURSE</h2>
                            <div cdkDropList #no14="cdkDropList" [cdkDropListData]="nonchickenmain"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of nonchickenmain; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>NON-VEG FISH MAIN COURSE</h2>
                            <div cdkDropList #no15="cdkDropList" [cdkDropListData]="nonfishmain"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of nonfishmain; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>NON-VEG MUTTON MAIN COURSE</h2>
                            <div cdkDropList #no16="cdkDropList" [cdkDropListData]="nonmuttonmain"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of nonmuttonmain; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>DESSERT</h2>
                            <div cdkDropList #no17="cdkDropList" [cdkDropListData]="dessert"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of dessert; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div cdkDropListGroup>
                        <div class="example-container">
                            <h2>CHUTNEY</h2>
                            <div cdkDropList #no18="cdkDropList" [cdkDropListData]="chutney"
                                [cdkDropListConnectedTo]="[user]" class="example-list" (cdkDropListDropped)="drop($event)">
                                @for (item of chutney; track item) {
                                <div class="example-box" cdkDrag>{{item.text}}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="columnright">
        <section>
        <div class="card">
            <div cdkDropListGroup>
                <div class="example-container1">
                    <h2>My Menu</h2>
                    <div cdkDropList #user="cdkDropList" [cdkDropListData]="userMenu"
                        [cdkDropListConnectedTo]="[no8,no9,no10,no11,no11,no12,no13,no14,no15,no16,no17,no18]" class="example-list1"
                        (cdkDropListDropped)="drop($event)">
                        @for (item of userMenu; track item) {
                        <div class="example-box1" cdkDrag>
                            <h1 style="color: brown;"></h1>
                            <div class='parent'>
                                <div class='child'>{{item.typedesc}}<br>{{item.text}}</div>
                                <div class='child'><img class="food-image" [src]="item.image" [alt]="item.text"></div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
</div>
